<template>
  <DeleteConfirm
      itemKey="TicketItemReport"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import TicketItemReportsAuth from '@/services/ticket-item-reports-auth'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return TicketItemReportsAuth
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť výkaz z ' + this.$moment(Item.workedAt).format('DD.MM.YYYY') + ' od ' + Item.User.name
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť výkaz z ' + this.$moment(Item.workedAt).format('DD.MM.YYYY') + ' od ' + Item.User.name + '?'
      },
      deleteData() {
        return TicketItemReportsAuth
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
